module.exports = __webpack_public_path__ + "img/refresh.2b48d032.svg";